import { t as e } from "../../constants-B7fXbm2f.js";
import { t } from "../../_plugin-vue_export-helper-B52Kst-M.js";
import { createElementBlock as n, createElementVNode as r, normalizeClass as i, openBlock as a } from "vue";
//#region ../src/icons/bluetooth-searching.vue
var o = {
	name: "DtIconBluetoothSearching",
	props: {
		size: {
			type: String,
			default: "500",
			validator: (t) => Object.keys(e).includes(t)
		},
		ariaLabel: {
			type: String,
			default: void 0
		}
	},
	emits: ["loaded"],
	computed: {
		iconSizeClass() {
			return e[this.size];
		},
		ariaHidden() {
			return this.ariaLabel ? "false" : "true";
		},
		dataQA() {
			return this.$attrs["data-qa"] ?? "dt-icon";
		}
	},
	created() {
		this.$emit("loaded");
	}
}, s = [
	"aria-label",
	"data-qa",
	"aria-hidden"
];
function c(e, t, o, c, l, u) {
	return a(), n("svg", {
		"aria-label": o.ariaLabel,
		class: i([u.iconSizeClass, "d-icon d-icon--bluetooth-searching"]),
		"data-qa": u.dataQA,
		"aria-hidden": u.ariaHidden,
		role: "img",
		"data-name": "Bluetooth Searching",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 12 12"
	}, [...t[0] || (t[0] = [r("path", {
		fill: "currentColor",
		"fill-rule": "evenodd",
		d: "M5.809.538a.5.5 0 0 1 .545.108l2.5 2.5a.5.5 0 0 1 0 .708L6.707 6l2.147 2.146a.5.5 0 0 1 0 .708l-2.5 2.5A.5.5 0 0 1 5.5 11V7.207L3.854 8.854a.5.5 0 1 1-.708-.708L5.293 6 3.146 3.854a.5.5 0 1 1 .708-.708L5.5 4.793V1a.5.5 0 0 1 .309-.462Zm.691 6.67L7.793 8.5 6.5 9.793V7.207Zm0-2.415V2.207L7.793 3.5 6.5 4.793Zm3.561-.561a.5.5 0 0 1 .707 0 2.5 2.5 0 0 1 0 3.537.5.5 0 0 1-.706-.708 1.5 1.5 0 0 0 0-2.122.5.5 0 0 1 0-.707ZM8.5 6a.5.5 0 0 1 .5-.5h.005a.5.5 0 0 1 0 1H9a.5.5 0 0 1-.5-.5Z",
		"clip-rule": "evenodd"
	}, null, -1)])], 10, s);
}
var l = /* @__PURE__ */ t(o, [["render", c]]);
//#endregion
export { l as default };

//# sourceMappingURL=bluetooth-searching.js.map